import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { BUILD_SHA, BUILD_TIME } from "../build-info";
// Inline build badge — sits next to the nav links in the header so the
// operator can confirm which build is live without devtools (especially
// on mobile). Click to expand the full build timestamp.
//
// Styling matches the user-email color (.build-badge in styles.css) so
// it reads as a passive identity field rather than another nav target.
export default function BuildBadge() {
    const [expanded, setExpanded] = useState(false);
    return (_jsxs("span", { className: "build-badge", onClick: () => setExpanded(e => !e), title: `build ${BUILD_TIME}`, children: ["[", BUILD_SHA, "]", expanded && (_jsxs("span", { className: "build-badge-time", children: ["@ ", BUILD_TIME] }))] }));
}
